//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

let timer = null;

export default{
  data() {
    return {
      open: false,
      tip: '',
      position: 'bottom',
      expires: 0,
    };
  },
  methods: {
    close() {
      this.open = false;
    },
    openModel(data) {
      this.open = true;
      this.tip = data.tip;
      this.position = data.position || 'bottom';
      this.expires = data.expires || 2500;
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        this.open = false;
        this.tip = null;
      }, this.expires);
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/Toast.vue